import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";

import {
  AppButton,
  AppErrorState,
  AppPage,
  AppShell,
  AppShellMain,
} from "../../ui-foundation";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <AppShell minHeight="100vh">
      <AppShellMain>
        <AppPage tag="main" justifyContent="center" maxWidth={720}>
          <AppErrorState
            title="Page not found"
            body="That Kindred page doesn’t exist, or the link is out of date."
            action={
              <Link to="/">
                <AppButton tone="primary">Return home</AppButton>
              </Link>
            }
          />
        </AppPage>
      </AppShellMain>
    </AppShell>
  );
};

export default NotFound;
